import Tax from './Tax.redux';

export default Tax;
